import { render } from "./Stage.vue?vue&type=template&id=18569a16&scoped=true"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"

import "./Stage.vue?vue&type=style&index=0&id=18569a16&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18569a16"]])

export default __exports__